var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08333 2.14286V17.8571C7.08333 19.0714 6.1625 20 4.95833 20H2.125C0.920833 20 0 19.0714 0 17.8571V2.14286C0 0.928571 0.920833 0 2.125 0H4.95833C6.1625 0 7.08333 0.928571 7.08333 2.14286ZM14.875 0H12.0417C10.8375 0 9.91667 0.928571 9.91667 2.14286V17.8571C9.91667 19.0714 10.8375 20 12.0417 20H14.875C16.0792 20 17 19.0714 17 17.8571V2.14286C17 0.928571 16.0792 0 14.875 0Z",
    fill: "#81818C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/PauseIcon.33d7430b.svg";
export { ForwardRef as ReactComponent };